export default __webpack_public_path__ + "static/media/DNo.20-3.73871f80.jpg";